export default __webpack_public_path__ + "static/media/mobile_native_dev_img2.25f2407a.svg";